import { PayloadAction } from '../../../../../store.model';
import { ActionType } from '../behaviour-selection-dialog.action';
import { BehaviourSelectionDialogState } from '../behaviour-selection-dialog.state';

import { CheckboxSelected } from './checkbox-selected.action';

export function checkboxSelectedReducer(
    state: BehaviourSelectionDialogState,
    action: PayloadAction<ActionType, CheckboxSelected>,
): BehaviourSelectionDialogState {
    const next = state.behaviourTagSelection?.map((e) =>
        e === action.payload.behaviourTag
            ? { ...e, isChecked: !e.isChecked }
            : e,
    );

    return {
        ...state,
        behaviourTagSelection: next,
    };
}
